/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-underscore-dangle */
import React, { useContext, useEffect, useState } from 'react';
import { Droppable } from 'react-beautiful-dnd';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { MainfieldWrapper, FieldWrapper, Field, ValidationWarning } from '../../common-field-styles';
import { assignFormDesignToCSSVars } from '../fields-customise.style';
import { shouldRenderFieldInRow } from '../../../../shared/form-lib';
import { FormContext } from '../../../shared/contexts/form-context';
import { ControlPropType } from '../../ctrl_proptype';
import AllowedFields from './allowed-row-fields';
import { RowContainer } from './add-row.styled';
import FieldInRow from './field-in-row';

const AddRow = ({ ctrl, rowCtrls, formDesign }) => {
  const controls = ctrl.props.controls;
  const { inBuilder } = useContext(FormContext);
  const { hiddenFields } = useSelector((state) => state.form);
  const [ctrlValidationError, setCtrlValidationError] = useState(ctrl._validationError ?? '');

  const addNewFieldInRow = (rowCtrlId, index) => {
    const rowCtrl = rowCtrls[rowCtrlId];
    const AllowedField = AllowedFields[rowCtrl?.type];
    if (AllowedFields[rowCtrl?.type]) {
      return (
        <FieldInRow
          index={index}
          ctrl={rowCtrl}
          formDesign={formDesign}
          id={rowCtrl.internal_id}
          key={rowCtrl.internal_id}
          AllowedField={AllowedField}
        />
      );
    }
  };

  useEffect(() => {
    if (inBuilder) setCtrlValidationError(ctrl._validationError);
  }, [inBuilder, ctrl._validationError]);

  useEffect(() => {
    if (inBuilder && controls.length > 0) setCtrlValidationError(null);
  }, [inBuilder, controls.length]);

  return (
    <MainfieldWrapper style={assignFormDesignToCSSVars(inBuilder, formDesign)}>
      <FieldWrapper>
        {ctrlValidationError && (
          <ValidationWarning className="ui bottom pointing basic label red">{ctrlValidationError}</ValidationWarning>
        )}

        {inBuilder ? (
          <Droppable droppableId={`${ctrl.internal_id} row-field`} direction="horizontal">
            {(provided, snapshot) => (
              <Field>
                <RowContainer
                  id="row-preview"
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                  isDraggingOver={snapshot.isDraggingOver}
                  isDropDisabled={controls.length === 3}>
                  {!controls.length && <p>Drag Field into this space</p>}
                  {controls.length > 0 &&
                    controls.map((rowCtrlId, index) => {
                      return addNewFieldInRow(rowCtrlId, index);
                    })}
                  {provided.placeholder}
                </RowContainer>
              </Field>
            )}
          </Droppable>
        ) : (
          <Field>
            <RowContainer
              notInBuilder={!inBuilder}
              formWidth={formDesign.design.custom_form_width}
              style={{
                '--grid-template-columns': `repeat(${controls.length}, 1fr)`,
              }}>
              {controls.length > 0 &&
                controls.map((rowCtrlId, index) => {
                  if (shouldRenderFieldInRow(rowCtrlId, hiddenFields)) {
                    return addNewFieldInRow(rowCtrlId, index);
                  }
                  return null;
                })}
            </RowContainer>
          </Field>
        )}
      </FieldWrapper>
    </MainfieldWrapper>
  );
};

AddRow.defaultProps = {
  formDesign: null,
};

AddRow.propTypes = {
  formDesign: PropTypes.shape({
    old: PropTypes.object.isRequired,
    design: PropTypes.object.isRequired,
  }),
  ctrl: PropTypes.shape(ControlPropType).isRequired,
  rowCtrls: PropTypes.objectOf(PropTypes.any).isRequired,
};
export default AddRow;
